import { c } from "./createLucideIcon-OVU-vHz1.js";
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], t = c("check", e);
export {
  t as C
};
